import { render, staticRenderFns } from "./TriggeredAlarmsTable.vue?vue&type=template&id=b6a0a9be&scoped=true"
import script from "./TriggeredAlarmsTable.vue?vue&type=script&lang=js"
export * from "./TriggeredAlarmsTable.vue?vue&type=script&lang=js"
import style0 from "./TriggeredAlarmsTable.vue?vue&type=style&index=0&id=b6a0a9be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a0a9be",
  null
  
)

/* custom blocks */
import block0 from "./TriggeredAlarmsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports